export default __webpack_public_path__ + "static/media/2.440d1f90.svg";